import React from 'react'
import { Request } from '@services/models'
import * as pageUtils from './__index.utils'
import { formatStrapiText } from '@utils/methods'
import Tooltip from '../tooltip'
import { DOSSIER_FORM } from './__index.utils'

type propsType = {
	request: Request
	requeteDateRecu: string | undefined
	pageData: any
	dossier: DOSSIER_FORM | undefined
	isPrincipal: boolean
	shouldDelayBeDisplayed: () => boolean
	getDelayValue: () => number | undefined
	getTooltipLabel: () => string
}

const RequestInfoSection: React.FC<propsType> = ({
	request,
	requeteDateRecu,
	pageData,
	dossier,
	isPrincipal,
	shouldDelayBeDisplayed,
	getDelayValue,
	getTooltipLabel
}) => {
	const responsable = dossier?.RESPONSABLE || ''
	const parts = responsable.trim().split(/\s+/)

	const emailIndex = parts.findIndex((p) => p.includes('@'))

	let nameValue = '-'
	let mailValue = '-'
	let telValue = '-'

	if (emailIndex !== -1) {
		nameValue = parts.slice(0, emailIndex).join(' ')
		mailValue = parts[emailIndex]
		telValue = parts.slice(emailIndex + 1).join(' ')
	}

	const renderInfoMultiLine = (
		label: string,
		nameValue: string,
		mailValue: string,
		telValue: string
	) => {
		return (
			<div className={pageUtils.classes.informationLine}>
				<span className={pageUtils.classes.infoQuestion}>
					<b>{formatStrapiText(label)}</b>
				</span>
				<span className={pageUtils.classes.infoAnswer}>{nameValue}</span>
				<span className={pageUtils.classes.infoAnswer}></span>
				<span className={pageUtils.classes.infoAnswer}>
					{mailValue !== '-' ? (
						<a
							href={`mailto:${mailValue}?subject=${encodeURIComponent(
								`${dossier?.NO_DOSSIER ? `${dossier.NO_DOSSIER} / ` : ''}${
									request?.code ? `${request.code}` : ''
								}${dossier?.OBJET ? ` - ${dossier.OBJET}` : ''}`
							)}`}
							style={{ color: 'inherit', textDecoration: 'underline' }}
						>
							{mailValue}
						</a>
					) : (
						'-'
					)}
				</span>
				<span className={pageUtils.classes.infoAnswer}></span>
				<span className={pageUtils.classes.infoAnswer}>{telValue}</span>
			</div>
		)
	}

	// Render a single information line
	const renderInfoLine = (label: string, value: string) => {
		return (
			<div className={pageUtils.classes.informationLine}>
				<span className={pageUtils.classes.infoQuestion}>
					<b>{formatStrapiText(label)}</b>
				</span>
				<span className={pageUtils.classes.infoAnswer}>{value}</span>
			</div>
		)
	}

	return (
		<div style={{ marginTop: '1.5rem' }}>
			{/* <div className={pageUtils.classes.informationLine}>
				<span className={pageUtils.classes.infoQuestion}>
					<b>
						{formatStrapiText(
							pageData?.assets?.request_form_confirmation_request_number_text
						)}
					</b>
				</span>
				<span className={pageUtils.classes.infoAnswer}>{request.code}</span>
			</div> */}

			{/* simple function de render au lieu de plusieurs blocs comme ci dessus */}

			{/* Numéro de requête */}
			{renderInfoLine(
				pageData?.assets?.request_form_confirmation_request_number_text,
				request.code
			)}

			{/* Numéro de dossier */}
			{renderInfoLine(
				pageData?.assets?.request_form_dossier_number,
				dossier?.NO_DOSSIER || '-'
			)}

			{/* Type de permis */}
			{renderInfoLine('Type de permis', dossier?.OBJET || '-')}

			{/* Date d'envoi de la requête */}
			{isPrincipal &&
				renderInfoLine("Date d'envoi de la requête", requeteDateRecu || '-')}

			{/* Date de création du dossier*/}
			{renderInfoLine(
				'Date de création du dossier',
				dossier?.DATE_CREAT || '-'
			)}

			<div className={pageUtils.classes.informationLine}>
				{isPrincipal && shouldDelayBeDisplayed() && (
					<>
						<span className={pageUtils.classes.infoQuestion}>
							<b>{pageData?.assets?.normed_first_action_treatment_label}</b>

							<div className={pageUtils.classes.infoTooltip}>
								<Tooltip
									showInfo
									infoLabel={getTooltipLabel()}
									isModal={false}
								/>
							</div>
						</span>
						<span className={pageUtils.classes.infoAnswer}>
							{getDelayValue()
								? getDelayValue() + ' ' + pageData?.assets?.label_days
								: pageData?.assets.normed_delays_no_subject_label}
						</span>
					</>
				)}
			</div>

			{/* Personne responsable */}
			{renderInfoMultiLine(
				'Personne responsable',
				nameValue,
				mailValue,
				telValue
			)}
		</div>
	)
}

export default RequestInfoSection
